export enum INPUT_TYPES {
  TEXT = "text",
  EMAIL = "email",
  PASSWORD = "password",
}

export enum HEADLINE_ORIENTATION {
  TOP = "top",
  BOTTOM = "bottom",
}

export enum SERVICE_PROCESS_DIRECTION {
  LEFT = "left",
  RIGHT = "right",
}
